﻿import React, { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { GetFailedRegs } from 'api/admin';

export default function FailedReg() {
  const [loading, setLoading] = useState(true);
  const [failedRegs, setFailedRegs] = useState(null);
  const [filteredRegs, setFilteredFailedRegs] = useState(null);
  const [selectedTextFilter, setSelectedTextFilter] = useState(null);

  const getFailedReqsQuery = useQuery({
    queryKey: ['getFailedRegs'],
    queryFn: async () => await GetFailedRegs({})(),
    enabled: false,
  });

  const shortSpan = {
    width: '250px',
    display: 'inline',
  };

  useEffect(() => {
    getFailedReqsQuery.refetch();
  }, []);

  useEffect(() => {
    if (getFailedReqsQuery.data != null) {
      setFailedRegs(JSON.parse(getFailedReqsQuery.data));
      setSelectedTextFilter('');
      setLoading(false);
    }
  }, [getFailedReqsQuery.data]);

  useEffect(() => {
    if (failedRegs !== null) {
      let regs = failedRegs;

      if (selectedTextFilter !== null && selectedTextFilter !== '') {
        regs = regs.filter(
          (f) =>
            (f.DisplayName != null &&
              f.DisplayName.toLowerCase().indexOf(selectedTextFilter.toLowerCase()) !== -1) ||
            (f.ProducerID != null && f.ProducerID.indexOf(selectedTextFilter) !== -1) ||
            (f.FailedDateTime != null && f.FailedDateTime.indexOf(selectedTextFilter) !== -1) ||
            (f.FailedCode != null &&
              f.FailedCode.toLowerCase().indexOf(selectedTextFilter.toLowerCase()) !== -1) ||
            (f.Reason != null &&
              f.Reason.toLowerCase().indexOf(selectedTextFilter.toLowerCase()) !== -1)
        );
      }

      setFilteredFailedRegs(regs);
    }
  }, [selectedTextFilter, failedRegs]);

  const DisplayTable = () => {
    return (
      <div className="container">
        <div className="row">
          <div className="col"></div>
        </div>
        <div className="row">
          <div className="col text-right">
            <span style={shortSpan}>
              Text Filter:&nbsp;
              <input
                type="text"
                id="failedRegTextFilter"
                className="form-control"
                style={{ display: 'inline', width: '200px' }}
                onBlur={(e) => setSelectedTextFilter(e.target.value)}
              />
            </span>
          </div>
        </div>
        {filteredRegs != null && (
          <div className="row">
            <div className="col">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Producer ID</th>
                    <th>Display Name</th>
                    <th>Failed Date</th>
                    <th>Reason</th>
                    <th>Entered Code</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredRegs.map((e, i) => {
                    return (
                      <tr key={i + 'row'}>
                        <td>{e.ProducerID}</td>
                        <td>{e.DisplayName}</td>
                        <td>{e.FailedDateTime}</td>
                        <td>{e.Reason}</td>
                        <td>{e.FailedCode}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    );
  };

  return <>{loading ? <div>Loading...</div> : DisplayTable()}</>;
}
